import { Incidents as ComponentIcidents } from "./Incidents";

export const Incidents = ComponentIcidents;
